<template>
  <div>
    <div class="row ml-3 participant">
      <div class="col-md-3 col-sm-12 mt-1">
        <label>Puesto:</label>
        <p class="font-weight-bold">
          {{ participant.positionName }}
        </p>
      </div>
      <div class="col-md-2 col-sm-12 mt-1">
        <label>Nombre:</label>
        <p class="font-weight-bold">
          {{ participant.fullName }}
        </p>
      </div>
      <div class="col-md-2 col-sm-12 mt-1">
        <label>Tipo de Firma:</label>
        <p class="font-weight-bold">
          {{ participant.participationTypeText }}
        </p>
      </div>
      <div class="col-md-4 col-sm-12 mt-1" v-if="canUploadDocument">
        <validation-observer ref="formValidator" v-if="!participant.hasSae08a || !switchDocumentComponent">
          <div class="row">
            <div class="col-8">
              <ValidationProvider
                v-slot="{ errors }"
                name="Archivo"
                :rules="participant.isDocumentRequired ? 'required' : null "
              >
                <CustomFileInput
                  ref="attachedDocument"
                  label="Documento:"
                  v-model="document"
                  :accept="'pdf'"
                  display-style="normal"
                  label-position="left"
                  :on-download="downloadFile"
                  :error="errors[0]"
                  custom-error-msg="Favor anejar documento."
                />
              </ValidationProvider>
            </div>
            <div class="col-4 mt-1">
              <action-button
                v-if="participant.hasSae08a"
                type="button"
                text="Cancelar"
                i="fa fa-times-circle"
                variant="outline-danger"
                class="ml-2 px-4 mb-3 actionButton mt-4"
                @click="cancelSectionToUploadDocument()"
              />
            </div>
          </div>      
        </validation-observer>  
        <div v-else>
          <div class="row">
            <div class="col-4">
              <label>Documento:</label>
              <p class="font-weight-bold">
                {{ participant.fileNameText }}
              </p>
            </div>
            <div class="col-6">
              <div slot="actions">
                <div class="dropdown text-right mt-3">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                    data-toggle="dropdown"
                  >
                    <span class="px-2">Acciones</span>
                    <i class="fa fa-angle-down" />
                  </button>
                  <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
                    <div
                      class="dropdown-item"
                      @click="downloadFile(participant.hasSae08aDocumentId)"
                    >
                      <em class="fa fa-download text-green pr-1" />
                      <span>Descargar</span>
                    </div>
                    <div
                      class="dropdown-item"
                      @click="showSectionToUpload"
                    >
                      <em class="fa fa-copy text-green pr-1" />
                      <span>Reemplazar</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="divider-horizontal" />
  </div>
</template>

<script>
import CustomFileInput from "CustomFileInput";
import ActionButton from 'ActionButton';
import _generalService from '@/services/pei/general';
export default {
  name: "Tab10ParticipantWithoutSignaturesRow",
  props: {
    participant: {
      type: Object,
      default: () => ({
        fullName: null,
        positionName: null,
        participationTypeText: null,
      })
    },
    peiDocumentAlternateParticipationDate:{
      type: String,
      default: () => null
    },
  },
  data(){
    return {
      document: null,
      switchDocumentComponent: true,
    }
  },
  components: {
    CustomFileInput,
    ActionButton
  },
  computed: {
    canUploadDocument() {
      let today = new Date();
      let dateParam = new Date(this.peiDocumentAlternateParticipationDate)

      today.setHours(0, 0, 0, 0);
      dateParam.setHours(0, 0, 0, 0);

      return dateParam && today >= dateParam;      
    }
  },   
  methods: {
    showSectionToUpload(){
      this.switchDocumentComponent = false;
    },
    cancelSectionToUploadDocument(){
      this.switchDocumentComponent = true;
    },
    downloadFile(uid){
       if (uid) {
        _generalService.downloadDocumentByAttachmentId(uid);
      }
    },
   async validate(){
      await this.$refs.formValidator.validate();
    },
  },
  watch: {
    document(newValue, oldValue) {
      let dataTosend = {
        file:newValue,
        idSignature: this.participant.peiSignatureId,
        email:this.participant.model.email,
        signatureTypeId:this.participant.model.type?this.participant.model.type.id:null
      };
      this.$emit("document", dataTosend);
    },
  }
};
</script>
<style scoped>
.divider-horizontal {
  border: 0.5px solid #e2e2e2;
  position: relative;
  top: 12px;
  width: 90%;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
</style>
